import React, { useEffect, useState } from "react";
import { CloseIcon, } from 'assets/icons'
import { Globals } from "utils";
import { Button, DatePicker, Input, Select } from "components";
import moment from "moment";
import { useSelector } from "react-redux";
import { ReportsService } from "services";

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalViewAppointmentProps {
  onClose: (reload?: boolean) => void,
  banks: any[]
  item: any
}

interface Form {
  appointment_id: string,
  payment_by_id: string,
  amount: string,
  bank_id: string,
  date: Date | null,
  reference: string,
}


const INITAL_STATE: Form = {
  appointment_id: '',
  payment_by_id: '',
  amount: '',
  bank_id: '',
  date: null,
  reference: '',
}

const ModalPaymentRegister = ({ onClose, banks, item }: ModalViewAppointmentProps) => {
  const user = useSelector((state: any) => state.user);
  const [form, setForm] = useState<Form>(INITAL_STATE);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (!item) return;


    const obj = {
      appointment_id: item?.id,
      amount: item?.appointment?.service?.price,
      date: new Date()
    }

    setForm({ ...INITAL_STATE, ...obj })
  }, [item])


  const onChange = (value: any, target: keyof typeof INITAL_STATE) => {

    if (target === 'reference') {
      if (value.length > 4) return
      if (isNaN(+value)) return
    }

    setForm(prev => ({ ...prev, [target]: value }));
  }

  const isFormValid = () => {
    if (!form.bank_id) {
      Globals.showError('Debe seleccionar un banco');
      return false;
    }

    if (!form.date) {
      Globals.showError('Debe seleccionar una fecha');
      return false;
    }

    if (!form.reference) {
      Globals.showError('Debe seleccionar una referencia');
      return false;
    }

    return true;
  }

  const onSubmit = async () => {
    if (!isFormValid()) return;
    try {
      setIsLoading(true);
      const data = {
        ...form,
        date: moment(form.date).format('YYYY-MM-DD'),
        payment_by_id: user.id,
      }

      await ReportsService.createPaymentsMade(data)
      Globals.showSuccess('El pago fue registrado exitosamente')
      onClose(true);
    } catch (error) {
      const err = error as any;
      Globals.showError(err?.response?.data?.error || 'Ocurrió un error al actualizar la consulta')
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div>
      <header>
        <p className="title">Registrar pago</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="form">
        <Select
          label="Banco"
          name="bank"
          value={form.bank_id}
          className="select"
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'bank_id')}
          options={banks}
        />

        <DatePicker
          label="Fecha"
          placeholder="Desde"
          maxDate={form.date || moment().toDate()}
          onChange={(v: string) => onChange(v, 'date')}
          value={form.date}
        />

        <Input
          label="Referencia"
          placeholder="Ultimos 4 digitos"
          value={form.reference}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'reference')}
        />

        <Button
          onClick={onSubmit}
          isLoading={isLoading}>
          Guardar
        </Button>
      </section>
    </div>
  )
}








export default ModalPaymentRegister